import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { ROOT_PATHS } from '../constants/paths.constants';
import { AuthService } from '../services/auth/auth.service';

export const noAuthenticationGuard = async (): Promise<boolean> => {
  const router = inject(Router);
  const authenticationService = inject(AuthService);

  try {
    const isLoginOn = await authenticationService.isLoginOn();
    if (isLoginOn) {
      await router.navigate([ROOT_PATHS.home]);
    }
    return true;
  } catch {
    return false;
  }
};
